import { logError } from '@ecomm/error-handling'
import { type SpringValue, useSpring } from '@react-spring/web'
import { voidFn } from '@simplisafe/ewok'
import { useEffect } from 'react'
import { usePromoBannerHasRendered } from './desktopBannerHasRendered'

export const useBannerAnimation = (): Record<string, SpringValue> => {
  const [promoBannerHasRendered, setPromoBannerHasRendered] =
    usePromoBannerHasRendered()

  const [springs, api] = useSpring(() => ({
    from: { minHeight: 0, maxHeight: 0, overflow: 'hidden' }
  }))

  useEffect(() => {
    if (!promoBannerHasRendered) {
      Promise.resolve(
        api.start({
          from: { minHeight: 0, maxHeight: 0, overflow: 'hidden' },
          to: { maxHeight: 1000, minHeight: 10, overflow: 'hidden' },
          delay: 1000,
          config: { duration: 1000 }
        })
      ).catch(logError)
      // We delay setting that the banner has rendered for 5 seconds.
      // This allows us to return an empty object for the springs, which means the min or max height is no longer set.
      // We need to unset the animation springs to prevent a gap from appearing as a user navigates around the site.
      // This is due to the page layout shifting slightly
      const timeout = setTimeout(() => {
        setPromoBannerHasRendered(true)
      }, 5000)
      return (): void => {
        clearTimeout(timeout)
      }
    }
  }, [api, promoBannerHasRendered, setPromoBannerHasRendered])

  return promoBannerHasRendered ? {} : springs
}
